module.exports = __webpack_public_path__ + "img/ic_meal.c5c70fec.svg";